import React, { Suspense, lazy } from 'react'

import PageLoader from '@Core/Components/Loading'

const Wrapper = lazy(() =>
  import(/* webpackChunkName: "terms-and-conditions" */ './view')
)

const LoaderWrapper = (props) => {
  return (
    <>
      <Suspense fallback={<PageLoader />}>
        <Wrapper {...props} />
      </Suspense>
    </>
  )
}

export default LoaderWrapper
